import { TestimonialCard } from "../../components/cards/TestimonialCard";
import { testimonials } from "../../data/testimonials";

export function HomeTestimonials() {
  return (
    <section className="section">
      <div className="section-kicker">About reviewbub</div>
      <div className="section-heading"><h2>Publicity support for authors who want more than a launch checklist.</h2><p>Writing the book is only one part of the journey. reviewbub helps authors shape the story around the book, reach the right media and reader communities, and understand what is happening throughout the campaign.</p></div>
      <div className="testimonial-grid">{testimonials.slice(0, 3).map((testimonial) => <TestimonialCard key={testimonial.name} testimonial={testimonial} />)}</div>
    </section>
  );
}
